import { create } from "zustand";

interface MaintenanceStore {
  isMaintenanceMode: boolean;
  setMaintenanceMode: (isActive: boolean) => void;
}

export const useMaintenanceStatusStore = create<MaintenanceStore>((set) => ({
  isMaintenanceMode: false,
  setMaintenanceMode: (isActive: boolean) => set({ isMaintenanceMode: isActive }),
}));
